var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('MenuLateral'),_c('v-main',{ref:"conteudo"},[_c('Header'),_c('transition',{attrs:{"name":"scroll-x-transition","mode":"out-in"},on:{"after-enter":_vm.focarTitulo}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }